import Mutations from '../../odata/mutations';

export default { ...new Mutations('subQuestion'), ...new Mutations('subQuestions') };
